import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Avatar,
  Image,
  Button,
  Badge,
  Typography,
  Dropdown,
  Tag,
  List,
  Spin,
} from "antd";
import { BellOutlined } from "@ant-design/icons";
import User from "../models/user/user";
import DiaryLogo from "assets/images/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { userDetails } from "redux/roles/userRoleSlice";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import {
  allDiaries,
  arciveDiaries,
  diaryStatus,
  saveAllDiaries,
  saveCurrentDiary,
  saveDiaryStatus,
  saveFromNotificationFlag,
  saveHideClassName,
} from "redux/diaries/diariesSlice";
import {
  DiaryStatusRoutes,
  PersonalityTypesEnum,
  downloadEvent,
  getInitials,
} from "utilities/generalUtility";
import InitialAvatar from "common/components/Initials/InitialAvatar";
import {
  allNotifications,
  CountNotification,
  fetchNotificationList,
  resetCountApi,
  saveFirstNotifications,
} from "redux/notification/notificationSlice";
import { globalSettings } from "redux/settings/settingSlice";

export default function Header() {
  const userData = useSelector(userDetails);
  const dispatch = useDispatch();
  const settings = useSelector(globalSettings);
  const notificationList = useSelector(allNotifications);
  const [loader, setLoader] = useState(false);
  const id = User.getUserId();
  const CountNotify = useSelector(CountNotification);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const viewportWidth = window.innerWidth;

  //resolveit
  const navigate = useNavigate();
  const location = useLocation();

  const diaries = useSelector(allDiaries);
  const archiveDiaries = useSelector(arciveDiaries);
  const currStatus = useSelector(diaryStatus);

  const getNotification = () => {
    setLoader(true);
    const body = {
      pageNumber: 1,
      pageSize: 20,
      userId: id,
    };
    dispatch(fetchNotificationList(body, false));
    setLoader(false);
  };

  const redirect = async (value, index) => {
    try {
      const data = { notificationId: value?.id };
      const obj = JSON.parse(value?.body ?? value?.Body);

      let diary;
      NetworkCall.fetch(Request.markNotiAsRead(data), false);
      if (obj?.DiaryId) {
        const check = diaries?.findIndex(
          (e) => e?.diaryId === parseInt(obj?.DiaryId)
        );
        diary = (check === -1 ? archiveDiaries : diaries).find(
          (e) => e?.diaryId === obj?.DiaryId
        );
        dispatch(saveDiaryStatus({ diary }));

        if (obj?.DiaryTopicId) {
          dispatch(
            saveCurrentDiary({
              diaryId: obj?.DiaryId,
              topicId: obj?.DiaryTopicId,
            })
          );
        } else {
          dispatch(
            saveCurrentDiary({
              diaryId: diary?.diaryId,
              topicId: diary?.topics[0]?.id,
              topicName: diary?.topics[0]?.name,
            })
          );
        }
        if (value?.type === 5 || value?.Type === 5) {
          const temp = check === -1 ? [...archiveDiaries] : [...diaries];
          const index = temp?.findIndex((e) => e?.diaryId === obj?.DiaryId);
          const tempTopics = [...temp[index]?.topics];

          const topicIndex = tempTopics.findIndex(
            (e) => e?.id === obj?.DiaryTopicId
          );
          const count = tempTopics[topicIndex]?.unseenMessageCount;
          tempTopics[topicIndex] = {
            ...tempTopics[topicIndex],
            unseenMessageCount: 0,
          };
          temp[index] = {
            ...temp[index],
            topics: [...tempTopics],
            totalUnseenMessageCountInDiary:
              temp[index]?.totalUnseenMessageCountInDiary - count,
          };
          dispatch(saveAllDiaries(temp));
          if (viewportWidth < 700) {
            dispatch(saveHideClassName("sider-none"));
          }
        } else if (value?.type === 3 || value?.Type === 3) {
          if (viewportWidth < 700) {
            dispatch(saveHideClassName("sider-none"));
          }
        }
        dispatch(saveFromNotificationFlag(true));
        const params = `?diaryId=${obj?.DiaryId}&diaryTopicId=${
          obj?.DiaryTopicId
        }${
          check === -1
            ? "&archivedNotification=true"
            : "&archivedNotification=false"
        }`;

        navigate(
          `${
            DiaryStatusRoutes[diary?.status?.id] ?? "/journal-request"
          }${params}`
        );

        // if (value?.type === 3 || value?.Type === 3) {
        //   if ( currStatus?.diary?.diaryId !== obj?.DiaryId) {
        //     navigate(
        //       `${
        //         DiaryStatusRoutes[diary?.status?.id] ?? "/journal-request"
        //       }${params}`
        //     );
        //   }
        // } else {

        // }
      }

      setDropDownOpen(false);
      const temp = [...notificationList];
      temp[index] = { ...temp[index], isRead: true };
      dispatch(saveFirstNotifications(temp));
    } catch (error) {}

    //if only diaryID then find the diary from diaries and then that diary id     dispatch(saveDiaryStatus({ diary }));
    // and if topicID as well then same as previous and diary topic id and diary id to        dispatch(saveCurrentDiary({ diaryId, topicId, topicName }));
  };

  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const { Header } = Layout;
  const { Text, Title } = Typography;

  const profileImage = User.getProfilePicture();

  useEffect(() => {
    User.isUserctive() && getNotification();
  }, []);

  const menuItems = (
    <Menu className="filter-dropdown settings-dropdown">
      <Menu.Item key="0">
        <Link to={"/account-settings"}>Account Settings</Link>
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={() => {
          downloadEvent("Logout");
          User.logoutCall();
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const NotificationDp = (
    <List className="notisfication-dp">
      {loader ? (
        <Spin></Spin>
      ) : notificationList?.length === 0 ? (
        <List.Item style={{ cursor: "pointer" }}>
          <Title level={5}>
            <span style={{ color: "black", fontWeight: "bold" }}>
              {"No Notification Found"}
            </span>{" "}
          </Title>
        </List.Item>
      ) : (
        notificationList?.slice(0, 5).map((e, index) => {
          const str = e?.message
            ? e?.message.split(" has ")
            : e?.Message.split(" has ");
          return (
            <List.Item
              id={e.id}
              style={{
                cursor: "pointer",
                backgroundColor: `${e.isRead ? "#FFFFFF" : "#F6F9FF"}`,
              }}
              onClick={() => redirect(e, index)}
            >
              <Title level={5}>
                <span style={{ color: "black", fontWeight: "bold" }}>
                  {str[0]}
                </span>{" "}
                <span
                  style={{
                    color: "black",
                    fontWeight: "normal",
                    fontSize: "14px",
                  }}
                >
                  {"has " + str[1]}
                </span>{" "}
              </Title>
            </List.Item>
          );
        })
      )}
      <Link
        to={"/notifications"}
        onClick={() => {
          setDropDownOpen(false);
        }}
      >
        <div className="text-center py-3">See More</div>
      </Link>
    </List>
  );

  return (
    <>
      <Header>
        <div style={{ cursor: "pointer" }} className="ant-layout-sider-logo">
          <Link
            to={
              location.pathname !== "/" &&
              userData?.subscriptionStatus &&
              (userData?.subscriptionStatus === "active" ||
                userData?.subscriptionStatus === "trialing")
                ? "/journal-request"
                : ""
            }
            className="d-inline-block"
          >
            <Image
              className="logo"
              preview={false}
              src={DiaryLogo}
              onClick={() => {
                if (
                  location.pathname === "/account-settings" ||
                  location.pathname === "/notifications"
                ) {
                  dispatch(saveDiaryStatus({}));
                  dispatch(saveCurrentDiary({}));
                }

                dispatch(saveHideClassName(""));
              }}
            />
          </Link>
        </div>

        <div
          onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}
          className="menu-overlay"
        ></div>
        <div className="app-header-right">
          {(userData?.subscriptionStatus === "active" ||
            userData?.subscriptionStatus === "trialing") && (
            <Dropdown
              overlay={NotificationDp}
              placement={"bottomRight"}
              disabled={!User.isUserctive()}
              arrow={{
                pointAtCenter: true,
              }}
              overlayClassName="notification-dropdown"
              trigger={["click"]}
              open={dropDownOpen}
              onOpenChange={(op) => {
                setDropDownOpen(op);
              }}
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
            >
              <Badge
                className="mr-3"
                count={CountNotify > 9 ? "9+" : CountNotify}
              >
                <Button
                  type="link"
                  shape="circle"
                  className="bell-icon"
                  icon={<BellOutlined />}
                  size="large"
                  onClick={() => CountNotify > 0 && dispatch(resetCountApi())}
                  disabled={
                    userData?.subscriptionStatus !== "active" &&
                    userData?.subscriptionStatus !== "trialing"
                  }
                />
              </Badge>
            </Dropdown>
          )}
          <div className="loggedin-user-dd">
            <Dropdown
              overlay={menuItems}
              placement="bottomRight"
              trigger={["click"]}
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
            >
              <a
                href="#menu"
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <Avatar
                  src={
                    profileImage === ""
                      ? userData?.firstName && (
                          <InitialAvatar
                            initials={getInitials(
                              userData?.firstName,
                              userData?.lastName
                            )}
                          />
                        )
                      : profileImage
                  }
                />
                {userData?.firstName && (
                  <>
                    {settings?.EnableAI === "1" &&
                      userData?.personalityProfileType && (
                        <Tag className="user-tag" color="#F08457">
                          {
                            PersonalityTypesEnum[
                              userData?.personalityProfileType
                            ]
                          }
                        </Tag>
                      )}
                    <Text className="user-name" style={{ marginLeft: "7px" }}>
                      {userData.firstName + " " + userData.lastName}
                    </Text>
                  </>
                )}
                <i className="icon-arrow-down"></i>
              </a>
            </Dropdown>
          </div>
        </div>
      </Header>
    </>
  );
}
